import {queryFnFetch} from '@github-ui/react-core/future/query-fn-fetch'
import {pullRequestsAppBuilder} from '../config/app-builder'
import {QueryRouteQueryType} from '@github-ui/react-core/future/data-router-types'
import type {NavigationCounterPageData} from '../page-data/payloads/tab-counts'
import {mainQuery} from '@github-ui/react-core/future/query-configs'
import type {LayoutRoutePayload} from './route-payload-types'

export const pullRequestsLayoutRoute = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsLayoutRoute', {
  path: '/:owner/:repo/pull/:pr_number',
  queries: [
    mainQuery<LayoutRoutePayload>({queryDeps: ({pathname}) => ({pathname})}),
    {
      queryName: 'tabCounts',
      queryDeps: ({params}) => {
        return {pathname: `/${params.owner}/${params.repo}/pull/${params.pr_number}/page_data/tab_counts`}
      },
      queryFn: async queryKey => queryFnFetch<NavigationCounterPageData>(queryKey),
      type: QueryRouteQueryType.Deferred,
    },
  ],
})
